module.exports = __webpack_public_path__ + "static/darkmantle-5a47816b927bcd8ca89fdacce27f5290.jpeg";